import { NoContentPlaceholder } from "../../../../components/NoContentPlaceholder.js";
import { RecordListItemHorizontal } from "./RecordListItemHorizontal.js";
import "react";
import { HorizontalScroll, Icon, Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { MdInventory } from "react-icons/md";
//#region src/modules/Records/shared/RecordsHorizontalScroll/RecordsHorizontalScroll.tsx
function RecordsHorizontalScroll({ data, loading, noContentElement, onClick, onRemove }) {
	if (loading && !data?.length) return /* @__PURE__ */ jsx("div", {
		className: "p-sm flex justify-center",
		children: /* @__PURE__ */ jsx(Loading, {
			message: "Getting recent records...",
			messagePosition: "vertical",
			size: "lg"
		})
	});
	if (!data?.length && !loading) return /* @__PURE__ */ jsx("div", {
		className: "flex h-40 items-center justify-center",
		children: noContentElement || /* @__PURE__ */ jsx(NoContentPlaceholder, {
			icon: /* @__PURE__ */ jsx(Icon, {
				Icon: MdInventory,
				size: "xxl"
			}),
			children: "No Records"
		})
	});
	return /* @__PURE__ */ jsx(HorizontalScroll, {
		itemWidth: 220,
		children: data?.map((record) => /* @__PURE__ */ jsx(RecordListItemHorizontal, {
			description: record.description,
			idLabel: record.idLabel,
			name: record.title,
			onClick: () => onClick(record.id),
			onRemove: onRemove ? () => onRemove(record.id) : void 0,
			primaryImageUrl: record.primaryImageUrl,
			type: record.type
		}, record.id))
	});
}
//#endregion
export { RecordsHorizontalScroll };

//# sourceMappingURL=RecordsHorizontalScroll.js.map